"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ContentShareConstants_1 = require("../contentsharecontroller/ContentShareConstants");

var DefaultModality = /*#__PURE__*/function () {
  function DefaultModality(_id) {
    _classCallCheck(this, DefaultModality);

    this._id = _id;
  }

  _createClass(DefaultModality, [{
    key: "id",
    value: function id() {
      return this._id;
    }
  }, {
    key: "base",
    value: function base() {
      if (!this._id) {
        return '';
      }

      return this._id.split(DefaultModality.MODALITY_SEPARATOR)[0];
    }
  }, {
    key: "modality",
    value: function modality() {
      if (!this._id) {
        return '';
      }

      var components = this._id.split(DefaultModality.MODALITY_SEPARATOR);

      if (components.length === 2) {
        return components[1];
      }

      return '';
    }
  }, {
    key: "hasModality",
    value: function hasModality(modality) {
      return modality !== '' && this.modality() === modality;
    }
  }, {
    key: "withModality",
    value: function withModality(modality) {
      var m = new DefaultModality(this.base() + DefaultModality.MODALITY_SEPARATOR + modality);

      if (modality === '' || this.base() === '' || new DefaultModality(m._id).modality() !== modality) {
        return new DefaultModality(this.base());
      }

      return m;
    }
  }]);

  return DefaultModality;
}();

exports.default = DefaultModality;
DefaultModality.MODALITY_SEPARATOR = ContentShareConstants_1.default.Modality[0];
DefaultModality.MODALITY_CONTENT = ContentShareConstants_1.default.Modality.substr(1);